<template>
    <div class="fixed z-index-modal top-0 overflow-hidden duration-500" :class="SideMenuStore.state.shoppingBag ? 'sidebar-open' : 'sidebar-close'">
        <div class="bg-black bg-opacity-70 w-screen h-screen fixed top-0 left-0"
             v-if="SideMenuStore.state.shoppingBag"
             @click="clickClose()"></div>
        <div class="w-full h-screen bg-a-egg-f5ebdc relative">
            <div class="text-24 font-bold py-6 text-center text-a-brown-502314">Shopping Bag</div>
            <div class="absolute top-6 right-6">
                <img class="cursor-pointer" @click="clickClose()" src="@/assets/icon/ic-close-brown.svg" />
            </div>
            <div v-if="SideMenuStore.state.shoppingBag">
                <div v-if="!isOrderEmpty">
                    <div class="px-6 hide-scroll overflow-y-auto order-list">
                        <CartOrderList
                            ref="cart-order-list"
                            @updateItem="onUpdateItem()"
                            @orderempty="onUpdateOrderEmpty()"
                            @onLoaded="onLoadSuccess()"
                        ></CartOrderList>
                    </div>
                    <div class="absolute bottom-25 lg:bottom-6 w-full px-20" >
                        <RedButton @click="clickSaveCart()">
                            Checkout
                        </RedButton>
                    </div>
                </div>
                <div v-else class="order-empty-screen flex">
                    <div class="m-auto w-full px-4">
                        <div class="flex w-full pb-1">
                            <img class="m-auto" src="@/assets/icon/ic-bag-empty-brown.svg" />
                        </div>
                        <div class="text-14  text-a-brown-9f8273 text-center pb-4">No cart item found</div>
                        <div class="flex w-full">
                            <RedButton customClass="w-64 py-2.5 m-auto" @click="clickGotoHome()">
                                Order Now!
                            </RedButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
//helper
import Util from '@/helper/Utility';
//component
import CartOrderList from '@/module/ShoppingCart/component/CartOrderList.vue';
import RedButton from '../../Button/RedButton.vue';
//model
import { SaveCartModel } from '@/module/ShoppingCart/model/SaveCartModel.js';
//service
import BKCart from '@/module/ShoppingCart/service/BKCart.js';
//mixin
import DeliveryMixin from '@/mixin/DeliveryMixin.js'
import ModalMixin from '@/mixin/ModalMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
export default {
    name: "ShoppingBag",
    mixins: [DeliveryMixin,ModalMixin,LocaleMixin],
    inject: ['SideMenuStore','CartCountStore','PlaceOrderStore'],
    components: {
        CartOrderList,
        RedButton
    },
    data: function() {
        return {
            pageActive: this.$route.name,
            isLoaded: false,
            isOrderEmpty: false,
            cartItemList: null,

            interval: null,
            isLoadedSaveCart: true
        };
    },
    watch:{
        $route: function() {
            this.closeMenu();
        },

        'SideMenuStore.state.shoppingBag': function () {
            let active = this.SideMenuStore.state.shoppingBag;
            console.log('side menu change', this.SideMenuStore.state.shoppingBag);
            setTimeout(() => {
                if (active) {
                    this.isLoaded = false;
                    this.isOrderEmpty = false;
                    document.body.classList.add('not-scroll');
                } else {
                    document.body.classList.remove('not-scroll');
                }
            }, 500);
        },
    },
    methods: {
        clickClose: function() {
            if (!this.isLoadedSaveCart) return;
            this.closeMenu();
        },
        closeMenu: function() {
            this.SideMenuStore.methods.closeShoppingBag();
        },
        openMenu: function() {
            this.SideMenuStore.methods.openShoppingBag();
            this.CartCountStore.methods.updateCartCount();
        },
        clickSaveCart: function() {
            if (this.interval) {
                clearInterval(this.interval);
            }

            if (this.checkSaveCart()) {
                this.saveCart(()=>{
                    this.closeMenu();
                    this.PlaceOrderStore.methods.removePlaceOrder();
                    this.gotoOrderSummary();
                });
            }
        },
        checkSaveCart: function() {
            if (this.delivery.deliveryMethod == "Delivery" && this.delivery.address) {
                return true;
            } else if (this.delivery.deliveryMethod == "InStore" && this.delivery.location && this.delivery.orderPlan) {
                return true;
            } else {
                this.closeMenu();
                this.modal.errorModal
                        .clearModal()
                        .setMsg(this.lbl.shoppingcart.error_address_not_found)
                        .show();
                this.modal.errorModal.onClose(()=> {
                    this.$router.push('/deliverymethod');
                })
                return false;
            }
        },
        saveCart: async function(callback) {
            let saveCartModel = new SaveCartModel();

            if (this.$refs['cart-order-list']) {
                saveCartModel.cartList = this.$refs['cart-order-list'].getData();
            } else {
                saveCartModel.cartList = [];
            }
            saveCartModel.setDelivery(this.delivery);

            this.modal.loadingModal.show();
            let isSaveCartSuccess = await this.apiSaveCart(saveCartModel);
            if (isSaveCartSuccess) {
                this.CartCountStore.methods.updateCartCount();
                if (Util.isFunction(callback)) {
                    callback();
                }
            }
        },
        gotoOrderSummary: function() {
            // this.$router.push("/ordersummary");
            const url = new URL('/ordersummary', window.location.origin)
            window.location.href = url.toString()
        },
        apiSaveCart: async function(saveCartModel) {
            return new Promise((resolve) => {
                let params = saveCartModel.getParams()
                BKCart.apiPostSaveCart(params).subscribe({
                    next: (data) => {
                        console.log(data);

                        this.isLoadedSaveCart = true;
                        this.modal.loadingModal.hide();
                        resolve(true);
                    },
                    error: (err) => {
                        this.isLoadedSaveCart = true;
                        this.modal.loadingModal.hide();
                        this.closeMenu();
                        resolve(false);
                        if (err.code == 409 && err.id == "1403") {
                            this.modal.errorModal
                                        .clearModal()
                                        .setMsg(this.lbl.shoppingcart.error_cart)
                                        .show();
                            this.modal.errorModal.onClose(()=> {
                                this.openMenu();
                            })
                        } else {
                            this.errorApi(err);
                        }
                    },
                });
            });
        },
        onLoadSuccess: function() {
            this.isLoaded = true;
        },
        onUpdateItem: function() {
            this.isLoadedSaveCart = false;
            if (this.interval) {
                clearInterval(this.interval);
            }
            this.interval = setInterval(() => {
                clearInterval(this.interval);
                if (this.checkSaveCart()) {
                    this.saveCart();
                }
            }, 3000);
        },
        onUpdateOrderEmpty: function () {
            this.isOrderEmpty = true;
        },
        clickGotoHome: function() {
            this.$router.push("/home");
            this.closeMenu();
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .sidebar-open {
        width: 100vw;
        right: 0px;
        @include min-desktop {
            width: 456px;
        }
    }
    .sidebar-close {
        width: 100vw;
        right: -100vw;
        @include min-desktop {
            width: 456px;
            right: -456px;
        }
    }

    .order-empty-screen {
        height: calc(100vh - 77px);
    }

    .order-list {
        height: calc(100vh - 240px);
        @include min-desktop {
            height: calc(100vh - 180px);
        }
    }
</style>
